module.exports = __webpack_public_path__ + "img/contact__raspberry.469ed3af.webp";